"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var BaseView_1 = require("@shared/views/BaseView");
var models_1 = require("@shared/models");
var DeckImageView = /** @class */ (function (_super) {
    __extends(DeckImageView, _super);
    function DeckImageView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.images = [];
        _this.defaultImage = null;
        _this.imageUrls = [];
        _this.options = {
            zoomed: _this.onZoom,
            rotate: _this.onRotate,
            viewed: _this.onViewed,
            hidden: _this.onHidden,
        };
        return _this;
    }
    DeckImageView.prototype.mounted = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _i, _c, i, defaultIndex, _d, _e, img;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, this.$api.deckImageService.list(this.model.id)];
                    case 1:
                        _b.images = _f.sent();
                        for (_i = 0, _c = this.images; _i < _c.length; _i++) {
                            i = _c[_i];
                            this.imageUrls.push(i.url);
                        }
                        // // FIND THE DEFAULT IMAGE
                        // if (this.images?.length) {
                        // 	this.defaultImage = this.images.find((x) => x.isDefault);
                        // }
                        // IF A DEFAULT IMAGE DOESN'T EXIST, LETS CREATE ONE
                        if (!this.defaultImage) {
                            this.defaultImage = new models_1.DeckImage({
                                url: "https://lurker.blob.core.windows.net/decks/d_deck_" + this.model.id + ".jpg?cb=" + Math.random().toString(24),
                                altText: this.model.name + " " + this.model.year,
                            });
                        }
                        else {
                            defaultIndex = this.images.findIndex(function (x) { return x.id === _this.defaultImage.id; });
                            this.images.splice(defaultIndex, 1);
                        }
                        for (_d = 0, _e = this.images; _d < _e.length; _d++) {
                            img = _e[_d];
                            if (!img.caption) {
                                img.caption = this.model.name + " " + this.model.year;
                                if ((_a = this.model.companies) === null || _a === void 0 ? void 0 : _a.length) {
                                    img.caption += " by " + this.model.companies[0].name;
                                }
                            }
                            if (!img.altText) {
                                img.altText = img.caption;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Fires when an image in the viewer component is zoomed in. */
    DeckImageView.prototype.onZoom = function (args) {
        // const src = args.target.firstChild.firstChild.currentSrc;
        // this.analytics.event('image-viewer', 'decks', 'rotate', src, args.detail.ratio );
    };
    /** Fires when an image in the viewer component is rotated. */
    DeckImageView.prototype.onRotate = function (args) {
        // const src = args.target.firstChild.firstChild.currentSrc;
        // this.analytics.event('image-viewer', 'decks', 'rotate', src, args.detail.degree);
    };
    /** Fires when an image in the viewer component is opened. */
    DeckImageView.prototype.onViewed = function (args) {
        // const src = args.target.firstChild.firstChild.currentSrc;
        // this.analytics.event('image-viewer', 'decks', 'viewed', src);
    };
    /** Fires when an image in the viewer component is closed. */
    DeckImageView.prototype.onHidden = function (args) {
        // const src = args.target.firstChild.firstChild.currentSrc;
        // this.analytics.event('image-viewer', 'decks', 'closed', src);
    };
    __decorate([
        vue_property_decorator_1.Prop({ type: Object })
    ], DeckImageView.prototype, "model", void 0);
    DeckImageView = __decorate([
        vue_property_decorator_1.Component({})
    ], DeckImageView);
    return DeckImageView;
}(BaseView_1.BaseView));
exports.default = DeckImageView;
